import { NotFound as DSNotFound } from "@jsq/ds/core";
import { ColumnContainer, Column } from "@jsq/ds/layouts";

const NotFound = () => (
  <ColumnContainer>
    <Column size="lg">
      <DSNotFound />
    </Column>
  </ColumnContainer>
);

export { NotFound };
